<template>
    <div class="cz2__step-groups-wrapper cz2__scrollbar-hide">
        <template v-if="isSpellingBee">
            <img
                class="cz2__sb-logo-d"
                src="../assets/images/branded/sb-final/SB-Logo_1_D@2x.webp"
                alt="Spelling Bee Logo"
            >

            <img
                class="cz2__sb-pop-logo-k"
                src="../assets/images/branded/sb-final/SB-Logo_2_K@2x.webp"
                alt="Spelling Bee Pop Logo"
            >
        </template>

        <main-navigation-list-toggles @switch="setActiveMenu" />

        <ul
            ref="navList"
            class="cz2__step-groups"
        >
            <li
                v-for="(group, index) in visibleGroups"
                :key="group.group.code"
            >
                <main-navigation-list-button
                    :shouldFocusOnLoad="index === 0"
                    :group="group.group"
                    :activePopId="activePopId"
                    :alert="group.alert"
                    :disabled="group.disabled"
                    @click.native="handleNavigateToGroup(group.group)"
                />
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__step-groups-wrapper {
            width: 100%;

            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;

            padding-left: 16px;

            .cz2__step-groups-pop-toggle-wrapper,
            .cz2__step-groups {
                width: 100%;
            }

            .cz2__step-groups {
                margin-top: 0;
                padding-bottom: 50px;

                list-style: none;

                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            @include respond-above(lg) {
                margin: 0 auto;
                margin-top: -4%;

                padding-left: 0;

                display: flex;
                justify-content: center;

                .cz2__step-groups-pop-toggle-wrapper,
                .cz2__step-groups {
                    max-width: 456px;
                }

                .cz2__step-groups {
                    height: 100%;
                }
            }

            @include respond-above(xl) {
                .cz2__step-groups-pop-toggle-wrapper,
                .cz2__step-groups {
                    max-width: 560px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__step-groups {
            justify-content: start;

            width: var(--vw100, 100vw);
            max-width: var(--vw100, 100vw);

            padding-left: 64px;
            padding-right: 64px;
            margin-top: 0;

            // Minus the padding that is already built-in.
            padding-top: 100px;

            // Our buttons ended up being 104px vs 98px specced.
            gap: calc(40px - 6px);
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__step-groups-wrapper {
            .cz2__step-groups-pop-toggle-wrapper, .cz2__step-groups {
                max-width: none;

                @include respond-above(lg) {
                    max-width: none;

                    padding-left: 32px;
                    padding-right: 32px;
                }
            }
        }

        .cz2__step-groups-wrapper {
            margin-left: -8px;
        }

        @include respond-above(lg) {
            .cz2__step-groups {
                padding-left: 0;
                padding-right: 0;
            }
            .cz2__step-groups-wrapper {
                margin-left: 0;
            }
            .cz2__sb-pop-logo-k {
                display: block;
                height: 100px;
                margin-top: 96px;
                margin-bottom: 16px;
            }
        }
    }

    #cz2.cz2__is-sb.cz2__is-kiosk {
        .cz2__sb-pop-logo-k {
            display: block;
            width: 600px;
            height: 154px;
            margin-top: 64px;
            margin-bottom: 32px;
            z-index: 1;
            // margin-top: 32px;
        }

        .cz2__sb-stars-logo-wrapper {
            display: none;
        }

        .cz2__step-groups-wrapper {
            margin-top: 0;

            .cz2__step-groups-pop-toggle-wrapper {
                margin-left: 0;
            }
        }

        .cz2__step-groups {
            padding-top: 0;
            padding-left: 110px;
            padding-right: 110px;
            gap: 16px;
        }
    }
</style>

<script>
    import { isBeardHeadAvailable } from '../helpers/outofstock';
    import { CLOSING_ANIMATION_DURATION_IN_MS } from '../constants';
    import MainNavigationListToggles from './MainNavigationListToggles.vue';
    import MainNavigationListButton from './MainNavigationListButton.vue';

    export default {
        components: {
            MainNavigationListToggles,
            MainNavigationListButton,
        },

        props: {
            isClosing: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                activePopId: null,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            seenGroupsByController() {
                return this.$store.state.customizer.seenGroupsByController[this.activePopId];
            },

            alertGroupsByController() {
                return this.$store.state.customizer.alertGroupsByController[this.activePopId];
            },

            navigableGroups() {
                return this.$store.getters.navigationGroups;
            },

            groups() {
                if (this.viewController == null) {
                    return [];
                }

                const filled = this.navigableGroups.map((group) => ({
                    group,
                    disabled: this.shouldDisableGroup(group.code),
                    alert: this.alertGroupsByController?.includes(group.code),
                }));

                // Prevent clicking on groups following an alerted group - a user must make a selection.
                let alerted = false;

                filled.forEach((g) => {
                    if (alerted) {
                        g.disabled = true;
                    }

                    if (g.alert) {
                        alerted = true;
                    }
                });

                return filled;
            },

            visibleGroups() {
                const dedupedGroups = this.groups
                    .filter((group, index, self) => self.findIndex((g) => g.group.name === group.group.name) === index);
                // Remove Head/Lashes step for non-babies
                const lashesRemoved = this.isBaby ? dedupedGroups : dedupedGroups.filter((g) => g.group.code !== 'Head');

                const filtered = lashesRemoved.map((group) => {
                    const sameNameGroups = this.groups.filter((g) => g.group.name === group.group.name);
                    const enabledGroup = sameNameGroups.find((g) => g.disabled === false);

                    if (enabledGroup) {
                        return enabledGroup;
                    }

                    const alertedGroup = sameNameGroups.find((g) => g.alert);

                    if (alertedGroup) {
                        return alertedGroup;
                    }

                    return sameNameGroups.find((g) => g.disabled);
                });

                return filtered;
            },

            isBaby() {
                return this.$store.getters.isBaby;
            },
        },

        mounted() {
            this.activePopId = this.viewController.id;

            // Put focus on the first element in the list
            this.$refs.navList.children[0].focus();
        },

        methods: {
            setActiveMenu(index) {
                this.activePopId = this.$store.getters.popControllers[index].id;
            },

            emitIsClosing(value) {
                this.$emit('update:isClosing', value);
            },

            navigateToGroup(group) {
                this.switchPops();

                this.emitIsClosing(true);

                setTimeout(() => {
                    this.$emit('close');
                    this.$store.dispatch('showGroup', group);
                    this.emitIsClosing(false);
                }, CLOSING_ANIMATION_DURATION_IN_MS);
            },

            handleNavigateToGroup(group) {
                this.$store.dispatch('setDidNavigateFromMainMenu', true);
                this.navigateToGroup(group);
            },

            switchPops() {
                if (this.activePopId !== this.viewController.id) {
                    const notCurrent = this.$store.getters.popControllers.find((x) => x.id === this.activePopId);

                    this.$store.dispatch('selectPop', notCurrent);
                }
            },

            shouldDisableGroup(groupCode) {
                const isGroupUnseen = !this.seenGroupsByController?.includes(groupCode);
                const isPacksAndBaby = groupCode === 'Packs' && this.isBaby;
                // disable beard step if no beard heads are available
                const isBeardHeadOos = groupCode === 'Beard' && !isBeardHeadAvailable(this.viewController);

                return isGroupUnseen || isPacksAndBaby || isBeardHeadOos;
            },
        },
    };
</script>
